import {
  initOnIframeResize,
  initOnIframeScroll,
  initOnWindowRedirect,
  onComponentLoaded,
  postArgusSession,
} from "@solvari/common-fe/helpers";

function initIframe() {
  initOnIframeResize();
  initOnWindowRedirect();
  initOnIframeScroll();

  onComponentLoaded("document", postArgusSession);
}

function main() {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initIframe);
  } else {
    initIframe();
  }
}

main();
